import React from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import history from '../../../history';

export const PAYMENT_ERROR = 'PAYMENT_ERROR';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const PAYMENT_LIST_SUCCESS = 'PAYMENT_LIST_SUCCESS';
export const PAYMENT_ERROR_CLEAR = 'PAYMENT_ERROR_CLEAR';

export const FETCH_PAYMENTS = 'FETCH_PAYMENTS';
export const FETCH_PAYMENT = 'FETCH_PAYMENT';
export const CREATE_PAYMENT = 'CREATE_PAYMENT';
export const DELETE_PAYMENT = 'DELETE_PAYMENT';
export const SETTLE_BATCH = 'SETTLE_BATCH';
export const SALES_REPORT = 'SALES_REPORT';

export const processSale = params => async (dispatch, getState) => {
  try {
    const response = await axios.post('/api/payments', params);
    dispatch({ type: CREATE_PAYMENT, payload: response.data });
    let transactionId = response.data.ttid;
    history.push(`/payments/${transactionId}`);
  } catch (error) {
    dispatch({ type: PAYMENT_ERROR, payload: error.response });
  }
};

export const settle = batchNumber => async (dispatch, getState) => {
  try {
    await axios.post('/api/payments/settled/1');
    history.push(`/payments/unsettled`);
  } catch (error) {
    dispatch({ type: PAYMENT_ERROR, payload: error.response });
  }
};

export const getPaymentDetails = paymentId => async (dispatch, getState) => {
  try {
    const response = await axios.get(`/api/payments/${paymentId}`);
    dispatch({ type: FETCH_PAYMENT, payload: response.data });
  } catch (error) {
    dispatch({ type: PAYMENT_ERROR, payload: error.response });
  }
};

export const voidPayment = paymentId => async (dispatch, getState) => {
  try {
    const response = await axios.delete(`/api/payments/${paymentId}`);
    dispatch({ type: DELETE_PAYMENT, payload: response.data });
  } catch (error) {
    dispatch({ type: PAYMENT_ERROR, payload: error.response });
  }
};

export const preAuthComplete = params => async (dispatch, getState) => {
  try {
    const response = await axios.patch(`/api/payments/${params.ttid}`, params);
    dispatch({ type: DELETE_PAYMENT, payload: response.data });
  } catch (error) {
    dispatch({ type: PAYMENT_ERROR, payload: error.response });
  }
};

export const getVoidList = () => async (dispatch, getState) => {
  try {
    const response = await axios.get('/api/payments/unsettled/1');
    dispatch({ type: FETCH_PAYMENTS, payload: response.data });
  } catch (error) {
    dispatch({ type: PAYMENT_ERROR, payload: error.response });
  }
};

export const getSettledList = () => async (dispatch, getState) => {
  try {
    const response = await axios.get('/api/payments/settled/1');
    dispatch({ type: FETCH_PAYMENTS, payload: response.data });
  } catch (error) {
    dispatch({ type: PAYMENT_ERROR, payload: error.response });
  }
};

export const getFailedList = () => async (dispatch, getState) => {
  try {
    const response = await axios.get('/api/payments/failed/1');
    dispatch({ type: FETCH_PAYMENTS, payload: response.data });
  } catch (error) {
    dispatch({ type: PAYMENT_ERROR, payload: error.response });
  }
};

export const getSalesReport = () => async (dispatch, getState) => {
  try {
    const response = await axios.get('/api/payments/settled/report/12');
    dispatch({ type: SALES_REPORT, payload: response.data });
  } catch (error) {
    dispatch({ type: PAYMENT_ERROR, payload: error.response });
  }
};

export const clearPaymentError = () => {
  return {
    type: PAYMENT_ERROR_CLEAR
  };
};

export const useClearPaymentError = () => {
  const dispatch = useDispatch();
  return React.useCallback(() => dispatch(clearPaymentError), [dispatch]);
};
